export const CAREER_PROSPECTS_4_CONSTANTS = {
  CAREER_PROSPECTS_FIELDS_CONFIG: [
    {
      fieldName: "certificate_image",
      label: "Desktop image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Foreground artwork (PNG / JPG / WebP)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "certificate_image_mobile",
      label: "Mobile image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Mobile artwork — falls back to desktop image if empty",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_image",
      label: "Desktop background image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Full-bleed background (desktop only)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "certificate_image_alt",
      label: "Image alt text",
      value: "Tools and frameworks",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "Tools and frameworks",
    },
    {
      fieldName: "title",
      label: "Headline",
      value: "Probable {Tools & Frameworks}",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Wrap words in { } to highlight them, e.g. Probable {Tools & Frameworks}",
      required: false,
      defaultValue: "Probable {Tools & Frameworks}",
      rows: 3,
    },
    {
      fieldName: "title_text_color",
      label: "Headline base color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "title_highlight_color",
      label: "Headline highlight color",
      value: "#DB5803",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Color of the words wrapped in { }",
      required: false,
      defaultValue: "#DB5803",
    },
    {
      fieldName: "background_color",
      label: "Section background color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable / disable section",
      defaultValue: true,
    },
  ],
};
